import React from 'react';
import PropTypes from 'prop-types';
import { SlideTitleContainer } from './CarouselSlide.style';

const CarouselSlideTitle = ({ title, subtitle }) => {
    if (title || subtitle) {
        return (
            <SlideTitleContainer className="odf-space-inner-left-s odf-space-inner-right-s">
                {title && (
                    <div className="odf-h4 odf-text-mono-color-09">{title}</div>
                )}
                {subtitle && (
                    <div className="odf-text-md odf-text-mono-color-09 odf-space-outer-top-xs">
                        {subtitle}
                    </div>
                )}
            </SlideTitleContainer>
        );
    }
    return null;
};

CarouselSlideTitle.defaultProps = {
    title: null,
    subtitle: null,
};

CarouselSlideTitle.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
};

export { CarouselSlideTitle };
